import { render, staticRenderFns } from "./omzet-summary.vue?vue&type=template&id=37368e4a&scoped=true&"
import script from "./omzet-summary.vue?vue&type=script&lang=js&"
export * from "./omzet-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37368e4a",
  null
  
)

export default component.exports